
class SeparadorMilesDirective {

    constructor() {

        this.restrict = 'A';
        this.require = 'ngModel';
    }

     _limpiarEntrada(input) {

        var esNegativo = input.indexOf("-") == 0;

        input = input.replace(/[\.\D]/g, '');
        if (input !== "") {
            input = Number(input);
            input = isNaN(input) ? "" : (input).toString();
        }

        return esNegativo ? "-" + input : input;
    }
    _formatear(input) {
         return input.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    _doGetCaretPosition(oField) {

        var iCaretPos = 0;

        if (document.selection) {
            oField.focus();
            var oSel = document.selection.createRange();
            oSel.moveStart('character', -oField.value.length);
            iCaretPos = oSel.text.length;
        }
        else if (oField.selectionStart || oField.selectionStart == '0') {
            iCaretPos = oField.selectionStart;
        }

        return iCaretPos;
    }

    _doSetCaretPosition(oField, pos, oldLength, newLength) {
        if (oldLength < newLength) {
            pos += (newLength - oldLength);
        } else if (oldLength > newLength) {
            pos -= (oldLength - newLength);
        }
        if (document.selection) {
            oField.focus();
            var oSel = document.selection.createRange();
            oSel.moveStart('character', -pos);
        } else {
            oField.selectionStart = pos;
            oField.selectionEnd = pos;
        }
    }


    link(scope, elem, attr, ngModelCtrl) {

        ngModelCtrl.$parsers.push((value) => {
            if (value == null || value === "") return null;

            var input = (value).toString();
            var oldLength = input.length;
            var newLength = oldLength;

            input = this._limpiarEntrada(input);

            var pos = this._doGetCaretPosition(elem[0]);

            if (input === "") {
                ngModelCtrl.$setViewValue("");
                ngModelCtrl.$render();
                return null;
            }

            var formatedInput = this._formatear(input);
            newLength = formatedInput.length;

            ngModelCtrl.$setViewValue(formatedInput);
            ngModelCtrl.$render();

            this._doSetCaretPosition(elem[0], pos, oldLength, newLength);

            var num = Number(input);

            return isNaN(num) ? null : num;
        });

        ngModelCtrl.$formatters.push((value) => {
            if (value == null || value === "") return null;
            if (!isNaN(value)) return this._formatear((value).toString());
            return null;
        });



    }
}

export default SeparadorMilesDirective;


// WEBPACK FOOTER //
// ./src/busqueda/directivas/separador-miles.directive.js